import { render } from "./Column3.vue?vue&type=template&id=c2282f6a"
import script from "./Column3.vue?vue&type=script&lang=js"
export * from "./Column3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__